const carRental = {
  carRental: "Alquiler de coches", // translated
  carRentals: "Alquiler de coches", // translated
  pickUpPoint: "Punto de recogida", // translated
  dropOffPoint: "Punto de entrega", // translated
  pickUpDate: "Fecha de recogida", // translated
  dropOffDate: "Fecha de entrega", // translated
  pickUp: "Levantar", // translated
  dropOff: "Dejar", // translated
  edit: "Editar", // translated
  fuelPolicy: "Política de combustible", // translated
  pickUpLocation: "Lugar de recogida", // translated
  mileage: "Kilometraje", // translated
  transmission: "Transmisión", // translated
  airCondition: "Aire acondicionado", // translated
  minimumAge: "Edad mínima", // translated
  maximumAge: "Edad máxima", // translated
  providerAddress: "Dirección del proveedor", // translated
  providerPhone: "Teléfono del proveedor", // translated
  driverInfo: "Información del conductor", // translated
  driversInfo: "Información del conductor", // translated
  differentDropOff: "Devolución en diferente lugar", // translated
  maxPassengers: "Pasajeros máximos", // translated
  budget: "Presupuesto", // translated
  provider: "Proveedor", // translated
  carModel: "Modelo de auto", // translated
  numOfDoors: "Número de puertas", // translated
  fuelType: "Tipo de combustible", // translated
  driverAge: "Edad del conductor", // translated
  workingHours: "Horas Laborales", // translated
  driverNationality: "Nacionalidad del conductor", // translated
  carRentalRate: "Tarifa de alquiler de coches", // translated
  dueNow: "Por ahora", // translated
  duePickUp: "Debe pagarse al momento de la recogida", // translated
  toViewOfferPDF: "Para ver un documento PDF que contiene todos los términos de alquiler de esta oferta, por favor", // translated
  toViewTermsAndCondPDF: "Para ver los términos y condiciones de CARNECT aplicables, por favor", // translated
};

export default carRental;
